import type { Dictionary } from "../i18n";

const dictionary: Dictionary = {
  "success.pendingTitle": "订单仍在确认中",
  "success.pendingBody": "付款确认所需时间比平时长。请勿再次付款。你可以再次查看、返回订单，或提供下方订单号联系支持团队。",
  "success.cancelledTitle": "此订单已取消",
  "success.cancelledBody": "如果你的银行卡已被扣款或预授权冻结，款项正在退回。你无需进行任何操作。",
  "success.checkAgain": "再次查看",

  "error.countryClosed": "此国家/地区已停止接受新订单及未付款订单的结账。已付款订单和客服支持将继续。",
  "error.providerCountryClosed": "指定的服务商已无法完成您的订单。请重新下单，我们将为您重新匹配。",
  "chrome.reviewTitle": "确认并付款", "chrome.paidTitle": "订单确认", "chrome.paymentTitle": "付款",
  "chrome.language": "语言", "chrome.close": "关闭", "chrome.logoAlt": "Tinkr",
  "common.loading": "正在加载", "common.error": "出现问题。", "common.retry": "重试",
  "common.labelSeparator": "：",
  "trust.badge": "由 Tinkr 销售 · 由经批准的本地打印合作伙伴制作",
  "review.orderSummary": "订单摘要", "review.threeD": "3D", "review.specsQty": "数量",
  "review.delivery.title": "配送", "review.shipping.title": "配送信息", "review.shipping.edit": "编辑",
  "review.payment.title": "付款方式", "review.payment.card": "信用卡/借记卡", "review.payment.cardHint": "支持 Visa、Mastercard 等",
  "review.payment.usdc": "USDC 稳定币", "review.payment.comingSoon": "即将推出",
  "review.price.title": "价格", "review.price.itemSubtotal": "商品小计", "review.price.premium": "优质制作", "review.price.shipping": "配送费",
  "review.price.shippingIncluded": "已包含", "review.price.total": "订单总额",
  "review.price.taxNote": "Tinkr 不会对本订单收取交易税。", "review.price.updating": "正在更新总额…",
  "review.price.refreshError": "无法刷新订单总额。请在付款前重新加载页面。",
  "review.price.multicolor": "多色",
  "review.price.multicolorCapNote": "我们无法精确测量这个手办，因此按多色最高价格收费。",
  "review.pricing.calculating": "正在计算你的准确价格…",
  "review.pricing.calculatingBody": "多色手办的价格根据其实际打印计算，通常不到一分钟即可完成。",
  "review.pricing.from": "起价",
  "review.pricing.stillWorking": "仍在计算中，感谢你的耐心等待。",
  "review.pricing.timeout": "我们未能完成价格计算，请重试。",
  "review.consent.prefix": "勾选即表示你同意 Tinkr 的", "review.consent.terms": "服务条款",
  "review.consent.and": "和", "review.consent.privacy": "隐私政策", "review.cta.pay": "付款", "review.cta.secure": "安全结账",
  "coupon.toggle": "有优惠码？", "coupon.label": "优惠码", "coupon.placeholder": "输入优惠码", "coupon.apply": "使用",
  "coupon.applying": "正在使用…", "coupon.remove": "移除", "coupon.removing": "正在移除…", "coupon.appliedLabel": "优惠码",
  "coupon.error.notFound": "找不到该优惠码", "coupon.error.expired": "该优惠码已过期", "coupon.error.revoked": "该优惠码已失效",
  "coupon.error.notStarted": "该优惠码尚未生效", "coupon.error.notApplicable": "该优惠码不适用于本订单",
  "coupon.error.usageLimit": "该优惠码已达到使用次数上限", "coupon.error.alreadyApplied": "该优惠码已使用",
  "coupon.error.retry": "请稍候再试", "coupon.error.generic": "该优惠码无法使用",
  "redirect.title": "正在前往安全付款页面…", "redirect.subtitle": "正在跳转到 Stripe 的安全付款页面。",
  "redirect.badgeVerified": "已验证", "redirect.badgeEncrypted": "已加密", "redirect.badgeSsl": "SSL 安全连接",
  "success.title": "付款完成！", "success.authorizedTitle": "订单已确认！", "success.orderNumber": "订单号",
  "success.paidTotal": "已付金额", "success.authorizedTotal": "银行卡临时预授权", "success.nextTitle": "接下来会发生什么",
  "success.step1": "打印合作伙伴会收到通知", "success.step2": "合作伙伴将打印并检查质量", "success.step3": "订单将配送给你",
  "success.statusCompleted": "已完成", "success.statusPending": "进行中", "success.statusUpcoming": "即将开始",
  "success.track": "跟踪订单", "success.viewOrder": "查看订单 →", "success.back": "返回 Tinkr",
  "success.returnToDoodles": "返回 Tinkr Doodles", "success.returnToSite": "返回你的订单",
  "success.confirming": "正在确认订单…", "success.notConfirmed": "暂时无法确认你的订单。请几分钟后再次查看。",
  "cancelled.title": "你已离开结账页面", "cancelled.body": "你的订单已保存。付款状态可能需要一点时间才能更新。", "cancelled.orderRef": "订单号",
  "cancelled.tip": "请检查网络连接或银行授权后重试。", "cancelled.retry": "重试", "cancelled.help": "帮助",
  "footer.terms": "服务条款", "footer.privacy": "隐私政策", "footer.refund": "退款与取消",
  "footer.seller": "卖家信息", "footer.tokushoho": "《特定商业交易法》声明", "footer.entity": "Tinkr App Ltd",
  "footer.companyNo": "公司编号",
  "legal.back": "返回", "legal.updated": "最后更新",
  "error.notFound": "找不到此结账链接。请检查邮件中的链接。", "error.expired": "此结账链接已过期。",
  "error.alreadyPaid": "此订单已付款。", "error.payFailed": "无法开始付款。请重试。",
  "error.couponNoLongerValid": "此订单使用的优惠码已失效。请移除后重试。",
  "error.couponLimitReached": "该优惠码目前已达到使用次数上限。请移除后继续，或稍后再试。",
  "error.couponNotApplicable": "此优惠码不适用于该订单金额。请移除后重试。",
  "error.paymentConfirming": "你的付款正在确认中。请稍候，然后刷新此页面。",
  "error.sessionConflict": "结账已在另一个窗口中更改。请重试。",
  "error.recoveryHint": "请打开最新的订单邮件以获取新的付款链接，或联系支持团队，我们会协助解决。",
  "error.backToSite": "返回网站"
};

export default dictionary;
